import { render } from "./property_list.vue?vue&type=template&id=6f5162ee&scoped=true"
import script from "./property_list.vue?vue&type=script&lang=js"
export * from "./property_list.vue?vue&type=script&lang=js"

import "./property_list.vue?vue&type=style&index=0&id=6f5162ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f5162ee"]])

export default __exports__